/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { instanceLevelMappingCreateRequestSchema } from './instanceLevelMappingCreateRequestSchema';
import { instanceTypeMappingCreateRequestSchema } from './instanceTypeMappingCreateRequestSchema';
import { integrationCustomFieldMappingCreateRequestSchema } from './integrationCustomFieldMappingCreateRequestSchema';
import { integrationFieldMappingsSchema } from './integrationFieldMappingsSchema';
import { integrationFiltersSchema } from './integrationFiltersSchema';
import { integrationSchedulePutRequestSchema } from './integrationSchedulePutRequestSchema';

export const launchIntegrationRequestSchema = z.object({
  get autoSync() {
    return z.union([integrationSchedulePutRequestSchema, z.null()]).optional();
  },
  get customFieldMappings() {
    return z.array(integrationCustomFieldMappingCreateRequestSchema);
  },
  get fieldMapping() {
    return integrationFieldMappingsSchema;
  },
  get filters() {
    return integrationFiltersSchema;
  },
  instanceId: z.string().min(1),
  instanceUrl: z.string().min(1),
  integrationInstanceId: z.int().nullish(),
  get itemLevelMappings() {
    return z.array(instanceLevelMappingCreateRequestSchema);
  },
  get itemTypeMappings() {
    return z.array(instanceTypeMappingCreateRequestSchema);
  },
  loopId: z.int(),
  name: z.string().nullish(),
  oauthCredentialsId: z.int(),
  sourceProjectId: z.string().min(1),
  sourceSystemType: z.enum(['JIRA', 'ADO']),
});
